/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const FLOW_STEP_SYNC = "sync";
export const FLOW_STEP_FORM = "form";
export const FLOW_STEP_HOOK = "hook";
export const FLOW_STEP_EVENT = "event";
export const FLOW_STEP_WRITER = "writer";
export const FLOW_STEP_COORDINATION_HOOK = "coordination-hook";
export const FLOW_STEP_WRITER_DOWNLOAD = "writer-download";
export const FLOW_STEP_JAVASCRIPT = "javascript";
export const FLOW_STEP_XSLTPROCESSOR = 'xsltprocessor';
export const FLOW_STEP_CRON = "cron";
export const FLOW_STEP_CONDITION = "condition";
export const FLOW_STEP_MERGE = "merge";
export const FLOW_STEP_MAPPER = "mapper";
export const FLOW_STEP_DELAY = "delay";
export const FLOW_STEP_DATIQUERY = "datiquery";
export const FLOW_STEP_JOIN = "join";
export const FLOW_STEP_MAIL = "mail";
export const FLOW_STEP_MANUAL_BUTTON = "manual-button";
export const FLOW_STEP_APPLY = "on-apply";
export const FLOW_STEP_BILLING = "on-billing";
export const FLOW_STEP_CONFIG = "on-config";
export const FLOW_STEP_DESTROY = "on-destroy";
export const FLOW_STEP_BLOCK = "on-block";
export const FLOW_STEP_UNBLOCK = "on-unblock";
export const FLOW_STEP_INVALID_APP = "on-invalid-app";
export const FLOW_STEP_VALID_APP = "on-valid-app";
export const FLOW_STEP_INVITATION_ACCEPT = "on-invitation-accept";
export const FLOW_STEP_INCOMING_MAIL = "incoming-mail";
export const FLOW_STEP_VALIDATOR = "validator";
export const FLOW_STEP_DOCUMENT_ENHANCER = "document-enhancer";
export const FLOW_STEP_ROSSUM_INITIALIZER = "rossum-initializer";
export const FLOW_STEP_CLIPBOARD = "clipboard";
export const FLOW_STEP_SYSTEM_JOB = "system-job";

export const FLOW_STEP_TYPES = {
    [FLOW_STEP_SYNC]: {
        name: "Sync data",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-refresh",
    },
    [FLOW_STEP_FORM]: {
        name: "Form",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-list-all",
        isAsync: false,
        deduplicate: false,
    },
    [FLOW_STEP_HOOK]: {
        name: "WebHook",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-crosshairs",
        isAsync: true,
        deduplicate: false,
    },
    [FLOW_STEP_MANUAL_BUTTON]: {
        name: "Manual Button",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-hand-pointer-o",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_EVENT]: {
        name: "Event",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-clone",
        isAsync: true,
        deduplicate: false,
    },
    [FLOW_STEP_WRITER]: {
        name: "Writer",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-pencil",
    },
    [FLOW_STEP_WRITER_DOWNLOAD]: {
        name: "Writer download",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-pencil",
    },
    [FLOW_STEP_VALIDATOR]: {
        name: "Writer Validator",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-pencil",
    },
    [FLOW_STEP_JAVASCRIPT]: {
        name: "JavaScript",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-file-text-o",
    },
    [FLOW_STEP_XSLTPROCESSOR]: {
        name: "XsltProcessor",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-file-text-o",
    },
    [FLOW_STEP_CRON]: {
        name: "CRON",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-clock-o",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_CONDITION]: {
        name: "Wait for condition",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-code-fork",
    },
    [FLOW_STEP_MERGE]: {
        name: "Merge data with default values",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-compress",
    },
    [FLOW_STEP_MAPPER]: {
        name: "Mapper",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-compress",
    },
    [FLOW_STEP_DELAY]: {
        name: "Delay",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: true,
        icon: "fa-hourglass",
    },
    [FLOW_STEP_DATIQUERY]: {
        name: "DatiQuery",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cube",
    },
    [FLOW_STEP_JOIN]: {
        name: "JOIN",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-code-fork"
    },
    [FLOW_STEP_MAIL]: {
        name: "Send Mail",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-envelope",
    },
    [FLOW_STEP_INCOMING_MAIL]: {
        name: "Receive Mail",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-envelope",
        isAsync: true,
        deduplicate: false,
    },
    [FLOW_STEP_APPLY]: {
        name: "On Flow Apply",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_COORDINATION_HOOK]: {
        name: "Coordination Hook",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-bow-arrow",
        isAsync: true,
        deduplicate: false,
    },
    [FLOW_STEP_CONFIG]: {
        name: "On Flow Config",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_DESTROY]: {
        name: "On Flow Destroy",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_BLOCK]: {
        name: "On Flow Block",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_UNBLOCK]: {
        name: "On Flow Unblock",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_INVALID_APP]: {
        name: "On Flow Invalid App",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_VALID_APP]: {
        name: "On Flow valid App",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-cloud-upload",
        isAsync: true,
        deduplicate: true,
    },
    [FLOW_STEP_CLIPBOARD]: {
        name: "Clipboard",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-clipboard",
    },
    [FLOW_STEP_DOCUMENT_ENHANCER]: {
        name: "Document enhancer",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-file-text-o",
    },
    [FLOW_STEP_ROSSUM_INITIALIZER]: {
        name: "Rossum Initializer",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        icon: "fa-cogs",
    },
    [FLOW_STEP_INVITATION_ACCEPT]: {
        name: "On Invitation Accept",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-user",
        isAsync: true,
    },
    [FLOW_STEP_BILLING]: {
        name: "On Billing",
        canBeStart: true,
        canBeMiddle: false,
        canBeEnd: false,
        requiresTransaction: false,
        icon: "fa-euro",
        isAsync: false,
    },
    [FLOW_STEP_SYSTEM_JOB]: {
        name: "System Job",
        canBeStart: false,
        canBeMiddle: true,
        canBeEnd: true,
        requiresTransaction: false,
        isAsync: false,
        isSystem: true,
    },
};

export const FETCH_DURABILITY_VERY_LONG = "very-long";
export const FETCH_DURABILITY_LONG = "long";
export const FETCH_DURABILITY_NORMAL = "normal";
export const FETCH_DURABILITY_SHORT = "short";
export const FETCH_DURABILITY_VERY_SHORT = "very-short";

export const FETCH_DURABILITY = {
    [FETCH_DURABILITY_VERY_LONG]: {
        name: "Very Long (2,5 months)",
        durabilityInHours: 2.5 * 31 * 24,
    },
    [FETCH_DURABILITY_LONG]: {
        name: "Long (1,5 months)",
        durabilityInHours: 1.5 * 31 * 24,
    },
    [FETCH_DURABILITY_NORMAL]: {
        name: "Normal (1 month)",
        durabilityInHours: 1 * 31 * 24,
    },
    [FETCH_DURABILITY_SHORT]: {
        name: "Short (2 week)",
        durabilityInHours: 14 * 24,
    },
    [FETCH_DURABILITY_VERY_SHORT]: {
        name: "Very Short (1 week)",
        durabilityInHours: 7 * 24,
    },
};

export default declareLinkedEntity({
    entity: "flowStepDefs",
    graphQL: "FlowStepDef",
    name: "Flow Step Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowStepDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Step Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Key",
            type: "string",
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: FLOW_STEP_EVENT,
            values: FLOW_STEP_TYPES,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        isStart: {
            name: "Is start",
            type: "boolean",
            defaultValue: false,
            visibility: (data) => { return FLOW_STEP_TYPES[data['type']] ? FLOW_STEP_TYPES[data['type']]['canBeStart'] : true; }
        },
        deduplicationStep: {
            name: "Deduplication Step",
            to: () => types['flowStepDefs'],
            type: "relation",
            relativeTo: ["flowDef"],
            visibility: (data) => { return data['isStart']; }
        },
        reportError: {
            name: "Report error",
            type: "boolean",
            defaultValue: false,
        },
        timeout: {
            name: "Timeout",
            type: "int",
            defaultValue: 300,
        },
        commitAfter: {
            name: "Commit after",
            type: "boolean",
            defaultValue: false,
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        countAsInvocation: {
            name: "Count as invocation",
            description: "When this step is run, count it as invocation in statistics",
            type: "boolean",
            defaultValue: true,
            visibility: (data) => { return data['isStart']; }
        },
        userActionNeeded: {
            name: "User action needed",
            type: "boolean",
            defaultValue: false,
        },
        form: {
            name: "Form",
            to: () => types['forms'],
            type: "relation",
            relativeTo: ["flowDef"],
            visibility: (data) => { return data['userActionNeeded']; }
        },
        flowStepConfigDef: {
            name: "Step Configuration",
            to: () => types['flowStepConfigDefs'],
            type: "relation",
            relativeTo: ["flowDef"],
        },
        flowCoordinationHook: {
            name: "Flow Coordination hook",
            to: () => types['flowCoordinationHooks'],
            type: "relation",
            relativeTo: ["flowDef"],
            visibility: (data) => { return data['type'] === FLOW_STEP_COORDINATION_HOOK; }
        },
        flowChannelDef: {
            name: "Application Definition",
            to: () => types['flowChannelDefs'],
            type: "relation",
            relativeTo: ["flowDef"],
        },
        entityDef: {
            name: "Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
        },
        fetchDurability: {
            name: "Fetch Durability",
            type: "enum",
            defaultValue: FETCH_DURABILITY_NORMAL,
            values: FETCH_DURABILITY,
            visibility: (data) => { return data['isStart']; }
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        x: {
            name: "X",
            type: "int",
            defaultValue: 0,
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        y: {
            name: "Y",
            type: "int",
            defaultValue: 0,
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        w: {
            name: "Width",
            type: "int",
            defaultValue: 200,
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        h: {
            name: "Height",
            type: "int",
            defaultValue: 120,
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        flowStepLinkDefs: {
            type: 'oneToMany',
            to: types['flowStepLinkDefs'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },
    }; }
});
